export default "/assets/site/images/majer_milan.png?51fa0e09d064d568795b24c930e4c260";